import React, { createContext, useContext, useMemo } from "react";
import type { ModulePermissions } from "@variphigen/shared-dashboards";
import { getDefaultModulePermissions } from "@variphigen/shared-dashboards";

interface ModuleConfigContextValue {
  modules: ModulePermissions;
  version: number;
  isLoading: boolean;
  isReady: boolean;
}

const ModuleConfigContext = createContext<ModuleConfigContextValue>({
  modules: getDefaultModulePermissions(),
  version: 0,
  isLoading: true,
  isReady: false,
});

export interface ModuleConfigProviderProps {
  modules?: ModulePermissions | null;
  version?: number;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function ModuleConfigProvider({
  modules,
  version = 0,
  isLoading = false,
  children,
}: ModuleConfigProviderProps): React.ReactElement {
  const value = useMemo(
    () => ({
      modules: modules ?? getDefaultModulePermissions(),
      version,
      isLoading,
      isReady: !isLoading,
    }),
    [modules, version, isLoading],
  );

  return (
    <ModuleConfigContext.Provider value={value}>{children}</ModuleConfigContext.Provider>
  );
}

export function useModuleConfigContext(): ModuleConfigContextValue {
  return useContext(ModuleConfigContext);
}
